const loop = (array: any[], key: string, callback: (item: any) => void, field = 'key') => {
  let index = 0;

  while (array[index]) {
    const item = array[index];

    if (item[field] === key) {
      callback({ item, index, array });

      return;
    }

    if (item.children && item.children.length) {
      loop(item.children, key, callback, field);
    }

    index++;
  }
};

export { loop };
